export const common = {
  english: "English",
  french: "French",
  moreDetails: "More Details",
  visit: "Visit",
  contact: "under construction",
  dark: "Dark",
  light: "Light",
};

export const landing = {
  sub1: "full stack;",
  sub1b: "web",
  sub2: "and",
  sub2b: "mobile app",
  sub3: "development.",
};

export const huehear = {
  desc: `<p>
  A web music player with a twist; This is a personal project I started in late 2019 to entertain my friends. HueHear is a web player for both Apple Music and Spotify that creates an ambient environment using the album covers you listen to. The primary colors are extracted from the album cover and sent over to Phillips Hue powered bulbs.
  <br/>
  <br/>
  Dance to the colors of your favorite artists!
</p>`,
};
export const strainprint = {
  desc: `<p>
  Strainprint helps cannabis patients track and compare the strains and effects they are experiencing. With a large collection of products and methods to track your symptoms, finding the most effective products just got easier.
  <br/>
  <br/>
  Strainprint is a ground up rebuild of the original, now in React Native; Available as an update on iOS and Android as of February 2021. 
  <br/>
  <br/>
  Check it out and find out more!
</p>`,
};
export const cobbl = {
  desc: `  <p>
  Featured in the <a href="https://angelhack.com/" target="_blank">AngelHack HACKcelerator</a> in 2018, cobbl was an iOS/Android app that showed street parking availability in the form of green and red lines displayed on a map.

</p>`,
};
export const sewingarmy = {
  desc:
    "The Sewing Army web app was built to help connect the wonderful community of sewists across North America to deliver PPE equipment where it's most needed!",
};

export const category = {
  web: "./WEB DEV",
  app: "./APP DEV",
};
